import { useEffect } from 'react';

const scriptSelector = 'script[data-repairy-inbox-widget]';
const scriptUrl = 'https://cdn.repairy.au/assets/repairy-inbox-widget.min.js';

let scriptPromise;

function loadScriptOnce() {
	if (scriptPromise) {
		return scriptPromise;
	}

	scriptPromise = new Promise((resolve, reject) => {
		const existing = document.querySelector(scriptSelector);
		if (existing) {
			if (existing.dataset.loaded === 'true') {
				resolve();
				return;
			}
			existing.addEventListener('load', () => resolve(), { once: true });
			existing.addEventListener('error', reject, { once: true });
			return;
		}

		const script = document.createElement('script');
		script.src = scriptUrl;
		script.async = true;
		script.dataset.repairyInboxWidget = 'true';
		script.addEventListener(
			'load',
			() => {
				script.dataset.loaded = 'true';
				resolve();
			},
			{ once: true }
		);
		script.addEventListener('error', reject, { once: true });
		document.body.appendChild(script);
	});

	return scriptPromise;
}

function applyConfig(el, config) {
	const attrs = {
		'shop-code': config.shopCode,
		'api-key': config.apiKey,
		'api-url': config.apiUrl,
		'fab-icon': config.fabIcon,
		'primary-color': config.primaryColor,
		'foreground-color': config.foregroundColor,
		'fab-label': config.fabLabel,
	};

	Object.keys(attrs).forEach((name) => {
		const value = attrs[name];
		if (value) {
			el.setAttribute(name, value);
		}
	});
}

export default function RepairyInboxWidget({ workshop }) {
	useEffect(() => {
		if (
			!workshop ||
			!workshop.inboxWidget ||
			!workshop.inboxWidget.shopCode ||
			!workshop.inboxWidget.apiKey
		) {
			return;
		}

		const {
			shopCode,
			apiKey,
			apiUrl,
			fabIcon,
			primaryColor,
			foregroundColor,
			fabLabel,
		} = workshop.inboxWidget;

		let cancelled = false;
		let widgetEl;

		loadScriptOnce()
			.then(() => {
				if (cancelled) {
					return;
				}
				widgetEl = document.createElement('rpry-inbox-widget');
				applyConfig(widgetEl, {
					shopCode,
					apiKey,
					apiUrl,
					fabIcon,
					primaryColor,
					foregroundColor,
					fabLabel,
				});
				document.body.appendChild(widgetEl);
			})
			.catch(() => {});

		return () => {
			cancelled = true;
			if (widgetEl) {
				widgetEl.remove();
			}
		};
	}, [workshop]);

	return null;
}
